import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../Text';
const StyledLabel = styled(Text).withConfig({
  displayName: "DropdownLabel__StyledLabel",
  componentId: "sc-1kqnwgg-0"
})(["display:block;margin:0;font:var(--text-md-bold);color:var(--neutral-text-high-emphasis);"]);
const StyledAuxiliaryText = styled(Text).withConfig({
  displayName: "DropdownLabel__StyledAuxiliaryText",
  componentId: "sc-1kqnwgg-1"
})(["display:block;margin:0;font:var(--text-sm-regular);color:var(--neutral-text-low-emphasis);"]);
const StyledLabelWrapper = styled.div.withConfig({
  displayName: "DropdownLabel__StyledLabelWrapper",
  componentId: "sc-1kqnwgg-2"
})(["flex:1;min-width:0;"]);
const StyledSuffix = styled.div.withConfig({
  displayName: "DropdownLabel__StyledSuffix",
  componentId: "sc-1kqnwgg-3"
})(["margin-left:var(--size-spacing-02);display:flex;align-items:center;"]);

/**
 * @ignore - do not document.
 */
const DropdownLabel = _ref => {
  let {
    label,
    auxiliaryText,
    truncate,
    suffix
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledLabelWrapper, null, /*#__PURE__*/React.createElement(StyledLabel, {
    truncate: truncate,
    forwardedAs: "span"
  }, label), auxiliaryText && /*#__PURE__*/React.createElement(StyledAuxiliaryText, {
    truncate: truncate,
    forwardedAs: "span"
  }, auxiliaryText)), suffix && /*#__PURE__*/React.createElement(StyledSuffix, null, suffix));
};
DropdownLabel.displayName = 'DropdownLabel';
DropdownLabel.defaultProps = {
  auxiliaryText: '',
  truncate: false
};
process.env.NODE_ENV !== "production" ? DropdownLabel.propTypes = {
  label: PropTypes.string.isRequired,
  auxiliaryText: PropTypes.string,
  truncate: PropTypes.bool,
  suffix: PropTypes.node
} : void 0;
export default DropdownLabel;